import type {
  AttemptsToEnablePrinting,
  SetOrderPrintingConfigParams,
} from '../domain';

interface Params {
  attempts: AttemptsToEnablePrinting;
  setAttempts: (params: AttemptsToEnablePrinting) => void;
  removeAttempts: () => void;
  setOrderPrintingConfig: (params: SetOrderPrintingConfigParams) => void;
}

/**
 * Manage the attempts to enable printing
 * @function runAttemptsToEnablePrinting
 * @returns {boolean} - if the printing has been enabled
 */
export function runAttemptsToEnablePrinting(params: Params): boolean {
  const {
    attempts,
    setAttempts,
    removeAttempts,
    setOrderPrintingConfig,
  } = params;
  const WEEK_IN_SECONDS = 604_800;
  const AMOUNT_ATTEMPTS_TO_ALLOW = 2;
  const CURRENT_DATE_IN_SEC = Math.trunc(Date.now() / 1_000);

  let isPrintedEnabled = false;
  if (isNaN(attempts.firstDate)) attempts.firstDate = CURRENT_DATE_IN_SEC;
  const diffTimeInSec = attempts.firstDate - CURRENT_DATE_IN_SEC;
  const isWithinTimeLimit = diffTimeInSec < WEEK_IN_SECONDS;

  if (!isWithinTimeLimit) {
    setAttempts({ amount: 0, firstDate: CURRENT_DATE_IN_SEC });
  } else if (isWithinTimeLimit && attempts.amount < AMOUNT_ATTEMPTS_TO_ALLOW) {
    setAttempts({ ...attempts, amount: attempts.amount + 1 });
  } else {
    isPrintedEnabled = true;
    removeAttempts();
    setOrderPrintingConfig({
      command: true,
      checklist: true,
      autoPrint: false,
    });
  }

  return isPrintedEnabled;
}
